(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bogo-collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const filterButton = event.target.closest('[data-bogo-filter]');
    if (!filterButton) return;

    const section = filterButton.closest('.bogo-collection-grid');
    if (!section) return;

    const filter = filterButton.dataset.bogoFilter;
    const products = section.querySelectorAll('[data-bogo-product]');
    const buttons = section.querySelectorAll('[data-bogo-filter]');
    const empty = section.querySelector('[data-bogo-empty]');
    let visibleCount = 0;

    buttons.forEach((button) => button.classList.toggle('is-active', button === filterButton));

    products.forEach((product) => {
      const tags = product.dataset.bogoTags || '';
      const isVisible = filter === 'all' || tags.split(' ').includes(filter);
      product.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (empty) empty.hidden = visibleCount > 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-discount-code-banner"] && !Shopify.designMode) return;
  try {
    
  const copyDiscountCode = async (button) => {
    const code = button.dataset.discountCode;
    const label = button.querySelector('[data-discount-code-label]');
    const status = button.parentElement.querySelector('[data-discount-code-status]');

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
      } else {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }

      button.classList.add('is-copied');
      label.textContent = button.dataset.copiedLabel;
      status.textContent = `${button.dataset.copiedLabel}: ${code}`;

      window.clearTimeout(button.discountCodeTimeout);
      button.discountCodeTimeout = window.setTimeout(() => {
        button.classList.remove('is-copied');
        label.textContent = button.dataset.copyLabel;
        status.textContent = '';
      }, 2400);
    } catch (error) {
      button.classList.remove('is-copied');
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-discount-code-copy]');
    if (!button) return;
    copyDiscountCode(button);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prelanding-avignone-listicle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('avignone-scroll-progress')) {
    customElements.define(
      'avignone-scroll-progress',
      class extends HTMLElement {
        connectedCallback() {
          this.story = this.closest('[data-avignone-story]');
          this.frame = null;
          this.requestUpdate = this.requestUpdate.bind(this);
          this.update = this.update.bind(this);
          window.addEventListener('scroll', this.requestUpdate, { passive: true });
          window.addEventListener('resize', this.requestUpdate, { passive: true });
          this.requestUpdate();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.requestUpdate);
          window.removeEventListener('resize', this.requestUpdate);
          if (this.frame) cancelAnimationFrame(this.frame);
        }

        requestUpdate() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(this.update);
        }

        update() {
          this.frame = null;
          if (!this.story) return;

          const scrollTop = window.scrollY || document.documentElement.scrollTop;
          const sectionTop = scrollTop + this.story.getBoundingClientRect().top;
          const sectionEnd = sectionTop + this.story.offsetHeight - window.innerHeight;
          const distance = sectionEnd - sectionTop;
          const progress = distance > 0 ? (scrollTop - sectionTop) / distance : 0;
          const clampedProgress = Math.min(1, Math.max(0, progress));

          this.style.setProperty('--av-story-progress', clampedProgress.toFixed(4));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-offerta-bundle"] && !Shopify.designMode) return;
  try {
    
  class BundleOffer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.products = this.readProducts();
      this.tiers = [...this.querySelectorAll('[data-bundle-tier]')];
      this.itemsContainer = this.querySelector('[data-bundle-items]');
      this.totalElement = this.querySelector('[data-bundle-total]');
      this.fullTotalElement = this.querySelector('[data-bundle-full-total]');
      this.addButton = this.querySelector('[data-add-bundle]');
      this.statusElement = this.querySelector('[data-bundle-status]');
      this.exclusiveOffers = [...this.querySelectorAll('[data-exclusive-offer]')];
      this.states = [];
      this.syncingCartDiscount = false;
      this.handleExternalCartUpdate = this.handleExternalCartUpdate.bind(this);
      document.addEventListener('cart:update', this.handleExternalCartUpdate);
      this.bindGallery();
      this.bindTiers();
      this.addButton?.addEventListener('click', () => this.addBundle());
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-add-exclusive-offer]');
        if (button) this.addExclusiveOffer(button);
      });
      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-exclusive-variant-select]');
        if (!input) return;
        const itemElement = input.closest('[data-exclusive-item]');
        const offerElement = input.closest('[data-exclusive-offer]');
        this.updateExclusivePrice(itemElement);
        this.updateExclusiveOffer(offerElement);
      });
      this.itemsContainer?.addEventListener('change', (event) => this.handleSelection(event));
      const activeTier = this.tiers.find((tier) => tier.classList.contains('is-active')) || this.tiers[0];
      if (activeTier) this.selectTier(activeTier);
      if (!this.products.length) this.setStatus(this.dataset.error, true);
    }

    readProducts() {
      try {
        const data = JSON.parse(this.querySelector('[data-bundle-products]')?.textContent || '[]');
        return data.filter((product) => product && Array.isArray(product.variants));
      } catch (error) {
        return [];
      }
    }

    bindGallery() {
      const mediaItems = [...this.querySelectorAll('[data-bundle-media]')];
      const buttons = [...this.querySelectorAll('[data-bundle-media-trigger]')];
      const arrows = [...this.querySelectorAll('[data-bundle-media-arrow]')];
      const pauseMedia = (item) => {
        item.querySelectorAll('video').forEach((video) => video.pause());
      };
      const activateMedia = (mediaId) => {
        mediaItems.forEach((item) => {
          const active = item.dataset.bundleMedia === mediaId;
          item.classList.toggle('is-active', active);
          if (!active) pauseMedia(item);
        });
        buttons.forEach((item) => {
          const active = item.dataset.bundleMediaTrigger === mediaId;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      };
      const moveMedia = (direction) => {
        if (mediaItems.length < 2) return;

        const activeIndex = mediaItems.findIndex((item) => item.classList.contains('is-active'));
        const currentIndex = activeIndex >= 0 ? activeIndex : 0;
        const nextIndex = direction === 'prev'
          ? (currentIndex - 1 + mediaItems.length) % mediaItems.length
          : (currentIndex + 1) % mediaItems.length;

        activateMedia(mediaItems[nextIndex].dataset.bundleMedia);
      };
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          activateMedia(button.dataset.bundleMediaTrigger);
        });
      });
      arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => moveMedia(arrow.dataset.bundleMediaArrow));
      });
    }

    bindTiers() {
      this.tiers.forEach((tier) => tier.addEventListener('click', () => this.selectTier(tier)));
    }

    selectTier(tier) {
      this.tiers.forEach((item) => {
        const active = item === tier;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      this.quantity = Math.max(1, Number.parseInt(tier.dataset.quantity, 10) || 1);
      this.states = Array.from({ length: this.quantity }, (_, index) => this.states[index] || this.defaultState(null));
      this.renderItems();
    }

    defaultState(productIndex) {
      const parsedIndex = Number.parseInt(productIndex, 10);
      const hasProduct = Number.isInteger(parsedIndex) && this.products[parsedIndex];
      if (!hasProduct && this.products.length !== 1) return { productIndex: null, options: [] };
      const resolvedIndex = hasProduct ? parsedIndex : 0;
      const product = this.products[resolvedIndex];
      const variant = product?.variants?.find((item) => item.available) || product?.variants?.[0];
      const optionNames = (product?.options || []).map((option) => typeof option === 'string' ? option : option.name);
      const options = optionNames.map((optionName, index) => {
        const normalizedName = String(optionName || '').trim().toLowerCase();
        return ['color', 'colour', 'colore'].includes(normalizedName) ? variant?.options?.[index] || '' : '';
      });
      return { productIndex: resolvedIndex, options };
    }

    handleSelection(event) {
      const select = event.target.closest('select');
      if (!select) return;
      const slot = Number.parseInt(select.dataset.slot, 10);
      if (!Number.isInteger(slot) || !this.states[slot]) return;
      if (select.matches('[data-product-select]')) {
        this.states[slot] = select.value === '' ? this.defaultState(null) : this.defaultState(Number.parseInt(select.value, 10));
      } else if (select.matches('[data-option-select]')) {
        const optionIndex = Number.parseInt(select.dataset.optionIndex, 10);
        this.states[slot].options[optionIndex] = select.value;
      }
      this.renderItems();
    }

    renderItems() {
      if (!this.itemsContainer) return;
      this.itemsContainer.replaceChildren();
      this.states.forEach((state, slot) => this.itemsContainer.append(this.createItem(state, slot)));
      this.updateTotal();
    }

    createItem(state, slot) {
      const product = Number.isInteger(state.productIndex) ? this.products[state.productIndex] : null;
      const card = document.createElement('article');
      card.className = 'bundle-offer__item';

      const media = document.createElement('div');
      media.className = 'bundle-offer__item-media';
      const imageSource = this.variantFor(state)?.featured_image?.src || product?.featured_image || product?.images?.[0] || '';
      if (imageSource) {
        const image = document.createElement('img');
        image.loading = 'lazy';
        image.alt = product?.title || '';
        image.src = imageSource;
        media.append(image);
      }

      const body = document.createElement('div');
      body.className = 'bundle-offer__item-body';
      const title = document.createElement('div');
      title.className = 'bundle-offer__item-title';
      const number = document.createElement('span');
      number.className = 'bundle-offer__item-number';
      number.textContent = String(slot + 1);
      const name = document.createElement('strong');
      name.textContent = product?.title || this.dataset.selectProduct;
      title.append(number, name);
      body.append(title);

      const fields = document.createElement('div');
      fields.className = 'bundle-offer__fields';
      if (this.products.length > 1) {
        fields.append(this.createField(this.dataset.selectProduct, this.products.map((item, index) => ({ value: String(index), label: item.title })), state.productIndex === null ? '' : String(state.productIndex), { slot, product: true }));
      }

      if (product) {
        const optionNames = (product.options || []).map((option) => typeof option === 'string' ? option : option.name);
        optionNames.forEach((optionName, optionIndex) => {
          const normalizedName = String(optionName || '').trim().toLowerCase();
          if (['color', 'colour', 'colore'].includes(normalizedName)) return;
          const values = [...new Set((product.variants || []).map((variant) => variant.options?.[optionIndex]).filter(Boolean))];
          fields.append(this.createField(optionName, values.map((value) => ({ value, label: value })), state.options[optionIndex] || '', { slot, optionIndex }));
        });
      }
      body.append(fields);
      card.append(media, body);
      return card;
    }

    createField(labelText, options, selected, metadata) {
      const field = document.createElement('div');
      field.className = `bundle-offer__field${metadata.product ? ' bundle-offer__field--product' : ''}`;
      const label = document.createElement('label');
      const select = document.createElement('select');
      const id = `Bundle-${this.dataset.bundleName.replace(/[^a-z0-9]+/gi, '-')}-${metadata.slot}-${metadata.product ? 'product' : metadata.optionIndex}`;
      label.htmlFor = id;
      label.textContent = labelText;
      select.id = id;
      select.required = true;
      select.dataset.slot = String(metadata.slot);
      if (metadata.product) select.dataset.productSelect = '';
      else {
        select.dataset.optionSelect = '';
        select.dataset.optionIndex = String(metadata.optionIndex);
      }
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = `Seleziona ${String(labelText || '').toLowerCase()}`;
      placeholder.disabled = true;
      placeholder.selected = selected === '';
      select.append(placeholder);
      options.forEach((item) => {
        const option = document.createElement('option');
        option.value = item.value;
        option.textContent = item.label;
        option.selected = String(item.value) === String(selected);
        select.append(option);
      });
      field.append(label, select);
      return field;
    }

    variantFor(state) {
      if (!state || !Number.isInteger(state.productIndex)) return null;
      const product = this.products[state.productIndex];
      const optionNames = (product?.options || []).map((option) => typeof option === 'string' ? option : option.name);
      return product?.variants?.find((variant) => variant.available && (variant.options || []).every((value, index) => {
        const normalizedName = String(optionNames[index] || '').trim().toLowerCase();
        if (['color', 'colour', 'colore'].includes(normalizedName)) return !state.options[index] || String(value) === String(state.options[index]);
        return state.options[index] && String(value) === String(state.options[index]);
      }));
    }

    resolvedVariants() {
      return this.states.map((state) => this.variantFor(state));
    }

    bundleIsValid() {
      const variants = this.resolvedVariants();
      return variants.length === this.quantity && variants.every(Boolean);
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
        style: 'currency',
        currency: this.dataset.currency || 'EUR'
      }).format(Number(cents || 0) / 100);
    }

    exclusiveVariant(itemElement) {
      if (!itemElement) return null;
      const input = itemElement.querySelector('[data-exclusive-variant-select]');
      const selectedOption = input?.selectedOptions?.[0];
      const fallbackId = String(itemElement.dataset.exclusiveFallbackVariantId || '').trim();
      const fallbackTitle = String(itemElement.dataset.exclusiveFallbackVariantTitle || '').trim();
      const variantId = String(input?.value || selectedOption?.value || fallbackId).trim();
      const selectedTitle = String(selectedOption?.textContent || '').trim();
      return variantId ? { id: variantId, title: selectedTitle || fallbackTitle } : null;
    }

    updateExclusivePrice(itemElement) {
      if (!itemElement) return;
      const input = itemElement.querySelector('[data-exclusive-variant-select]');
      const selectedOption = input?.selectedOptions?.[0] || input;
      const salePrice = selectedOption?.dataset?.price;
      const fullPrice = selectedOption?.dataset?.comparePrice;
      const salePriceElement = itemElement.querySelector('[data-exclusive-sale-price]');
      const fullPriceElement = itemElement.querySelector('[data-exclusive-full-price]');

      if (salePriceElement && salePrice) salePriceElement.textContent = this.formatMoney(salePrice);
      if (fullPriceElement && fullPrice) {
        const compare = Number(fullPrice || 0);
        const price = Number(salePrice || 0);
        fullPriceElement.textContent = compare > price ? this.formatMoney(compare) : '';
      }
    }

    updateExclusiveOffer(offerElement) {
      if (!offerElement) return;
      const button = offerElement.querySelector('[data-add-exclusive-offer]');
      const lockElement = offerElement.querySelector('[data-exclusive-lock]');
      if (button) button.disabled = false;
      if (lockElement) lockElement.hidden = true;
      this.setExclusiveStatus(offerElement, '', false);
    }

    updateAllExclusiveOffers() {
      this.exclusiveOffers.forEach((offerElement) => this.updateExclusiveOffer(offerElement));
    }

    exclusiveMarker(offerElement) {
      return String(offerElement?.dataset?.exclusiveMarker || 'ADD-ON AVIGNONE').trim();
    }

    exclusiveVariantIds(offerElement) {
      const items = offerElement
        ? [...offerElement.querySelectorAll('[data-exclusive-item]')]
        : this.exclusiveOffers.flatMap((item) => [...item.querySelectorAll('[data-exclusive-item]')]);
      return items.flatMap((itemElement) => String(itemElement.dataset.exclusiveVariantIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean));
    }

    cartHasExclusiveAddOn(cart, marker, offerElement) {
      const offerVariantIds = this.exclusiveVariantIds(offerElement);
      const addOnVariantIds = new Set(offerVariantIds.map((id) => String(id)));
      return (cart?.items || []).some((item) => {
        const properties = item.properties || {};
        return Boolean(marker && properties[marker]) || addOnVariantIds.has(String(item.variant_id || item.id));
      });
    }

    cartAvignoneQuantity(cart) {
      const bundleProperty = this.dataset.bundleProperty;
      const bundleName = this.dataset.bundleName;
      return (cart?.items || []).reduce((total, item) => {
        const properties = item.properties || {};
        const productName = `${item.product_title || ''} ${item.handle || ''} ${item.title || ''}`.toLowerCase();
        const isAvignone = productName.includes('avignone') || properties[bundleProperty] === bundleName;
        return isAvignone ? total + Number(item.quantity || 0) : total;
      }, 0);
    }

    cartDiscountEligible(cart, offerElement) {
      const marker = this.exclusiveMarker(offerElement);
      return this.cartAvignoneQuantity(cart) >= 3 && this.cartHasExclusiveAddOn(cart, marker, offerElement);
    }

    cartHasDiscountCode(cart, discountCode) {
      const normalizedCode = String(discountCode || '').trim().toLowerCase();
      if (!normalizedCode) return false;

      const applications = [
        ...(cart?.cart_level_discount_applications || []),
        ...(cart?.discount_applications || []),
        ...(cart?.items || []).flatMap((item) => item.line_level_discount_allocations || [])
      ];

      return applications.some((application) => {
        const values = [
          application?.title,
          application?.code,
          application?.discount_application?.title,
          application?.discount_application?.code
        ];
        return values.some((value) => String(value || '').trim().toLowerCase() === normalizedCode);
      });
    }

    async handleExternalCartUpdate(event) {
      const source = String(event?.detail?.data?.source || '');
      const hasExclusiveDiscount = this.exclusiveOffers.some((offerElement) => String(offerElement.dataset.exclusiveDiscountCode || '').trim());
      if (!hasExclusiveDiscount || source.startsWith('bundle-offer')) return;
      if (this.syncingCartDiscount) return;

      this.syncingCartDiscount = true;
      try {
        await this.applyExclusiveDiscount();
        await this.refreshCart('bundle-offer-discount-sync', 0, '');
      } finally {
        this.syncingCartDiscount = false;
      }
    }

    setExclusiveStatus(offerElement, message, error) {
      const statusElement = offerElement?.querySelector('[data-exclusive-status]');
      if (!statusElement) return;
      statusElement.textContent = message || '';
      statusElement.toggleAttribute('data-error', Boolean(error));
    }

    updateTotal() {
      const variants = this.resolvedVariants();
      const valid = variants.length === this.quantity && variants.every(Boolean);
      if (this.addButton) this.addButton.disabled = !this.products.length;
      if (!valid) {
        if (this.totalElement) this.totalElement.textContent = '—';
        if (this.fullTotalElement) this.fullTotalElement.textContent = '—';
        this.setStatus('', false);
        this.updateAllExclusiveOffers();
        return;
      }
      this.setStatus('', false);
      const offerTotal = variants.reduce((sum, variant) => sum + Number(variant.price || 0), 0);
      const fullTotal = variants.reduce((sum, variant) => sum + Math.max(Number(variant.compare_at_price || 0), Number(variant.price || 0)), 0);
      if (this.fullTotalElement) this.fullTotalElement.textContent = this.formatMoney(fullTotal);
      if (this.totalElement) this.totalElement.textContent = this.formatMoney(offerTotal);
      this.updateAllExclusiveOffers();
    }

    setStatus(message, error) {
      if (!this.statusElement) return;
      this.statusElement.textContent = message || '';
      this.statusElement.toggleAttribute('data-error', Boolean(error));
    }

    async addBundle() {
      const variants = this.resolvedVariants();
      if (variants.length !== this.quantity || variants.some((variant) => !variant)) {
        this.setStatus(this.dataset.unavailable, true);
        this.itemsContainer?.querySelector('select:not(:disabled):invalid, select:not(:disabled)')?.focus();
        return;
      }
      const label = this.addButton.querySelector('span');
      const originalLabel = label?.textContent;
      this.addButton.disabled = true;
      if (label) label.textContent = this.dataset.added || originalLabel;
      this.setStatus('', false);
      try {
        const items = this.bundleLineItems();
        const response = await fetch(this.cartEndpoint('add'), {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error(await this.cartErrorMessage(response));
        await this.applyExclusiveDiscount();
        await this.refreshCart('bundle-offer', items.reduce((total, item) => total + Number(item.quantity || 0), 0), String(items[0]?.id || ''));
        this.openCart();
      } catch (error) {
        this.setStatus(error?.message || this.dataset.error, true);
        this.addButton.disabled = false;
        if (label) label.textContent = originalLabel;
      }
    }

    bundleLineItems() {
      const groupedItems = new Map();
      this.resolvedVariants().forEach((variant, index) => {
        const id = String(variant.id);
        const existingItem = groupedItems.get(id);
        const position = index + 1;
        if (existingItem) {
          existingItem.quantity += 1;
          existingItem.positions.push(position);
          existingItem.properties[this.dataset.itemProperty] = `${existingItem.positions.join(', ')}/${this.quantity}`;
          return;
        }
        groupedItems.set(id, {
          id,
          quantity: 1,
          positions: [position],
          properties: {
            [this.dataset.bundleProperty]: this.dataset.bundleName,
            [this.dataset.itemProperty]: `${position}/${this.quantity}`
          }
        });
      });
      return [...groupedItems.values()].map(({ positions, ...item }) => item);
    }

    cartRoot() {
      const shopifyRoot = window.Shopify?.routes?.root;
      const root = String(shopifyRoot || this.dataset.cartRoot || '/').trim() || '/';
      return root.endsWith('/') ? root : `${root}/`;
    }

    cartEndpoint(type) {
      const endpoints = {
        add: this.dataset.cartAddUrl,
        cart: this.dataset.cartUrl,
        update: this.dataset.cartUpdateUrl
      };
      const endpoint = String(endpoints[type] || '').trim();
      if (endpoint.startsWith('/')) return endpoint;
      const fallback = type === 'add' ? 'cart/add.js' : type === 'update' ? 'cart/update.js' : 'cart.js';
      return `${this.cartRoot()}${fallback}`;
    }

    async cartErrorMessage(response) {
      try {
        const contentType = response.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
          const data = await response.json();
          const errorMessage = data?.description || data?.message || data?.errors;
          if (typeof errorMessage === 'string') return errorMessage;
          if (errorMessage) return JSON.stringify(errorMessage);
        }
        const text = await response.text();
        const cleanText = text.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        return cleanText || `${this.dataset.error} (${response.status})`;
      } catch (error) {
        return `${this.dataset.error} (${response.status})`;
      }
    }

    async addExclusiveOffer(button) {
      const offerElement = button?.closest('[data-exclusive-offer]');
      const itemElement = button?.closest('[data-exclusive-item]');
      const exclusiveVariant = this.exclusiveVariant(itemElement);
      if (!exclusiveVariant) {
        const sizeLabel = itemElement?.querySelector('.bundle-offer__exclusive-field span')?.textContent || 'taglia';
        this.setExclusiveStatus(offerElement, `Seleziona ${String(sizeLabel).toLowerCase()} per aggiungere l’offerta.`, true);
        itemElement?.querySelector('[data-exclusive-variant-select]')?.focus();
        return;
      }

      const originalLabel = button?.textContent;
      if (button) {
        button.disabled = true;
        button.textContent = this.dataset.loading;
      }
      this.setExclusiveStatus(offerElement, '', false);

      try {
        const exclusiveProperties = {
          [offerElement?.dataset?.exclusiveProperty || 'Offerta esclusiva']: this.dataset.bundleName
        };
        if (exclusiveVariant.title) exclusiveProperties.Taglia = exclusiveVariant.title;
        const exclusiveMarker = this.exclusiveMarker(offerElement);
        if (exclusiveMarker) exclusiveProperties[exclusiveMarker] = 'Sì';

        const items = [
          {
            id: String(exclusiveVariant.id),
            quantity: 1,
            properties: exclusiveProperties
          }
        ];
        const response = await fetch(this.cartEndpoint('add'), {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error(await this.cartErrorMessage(response));
        await this.applyExclusiveDiscount();
        await this.refreshCart('bundle-offer-exclusive', 1, String(exclusiveVariant.id));
        this.openCart();
        if (button) {
          button.disabled = false;
          button.textContent = originalLabel;
        }
      } catch (error) {
        this.setExclusiveStatus(offerElement, error?.message || this.dataset.error, true);
        if (button) {
          button.disabled = false;
          button.textContent = originalLabel;
        }
      }
    }

    async applyExclusiveDiscount() {
      const payload = {};

      try {
        const cartResponse = await fetch(this.cartEndpoint('cart'), {
          headers: { Accept: 'application/json' }
        });
        if (!cartResponse.ok) return;
        const cart = await cartResponse.json();
        const attributes = {};
        const discountCodes = [];

        const configuredDiscountCodes = [];
        this.exclusiveOffers.forEach((offerElement) => {
          const marker = this.exclusiveMarker(offerElement);
          const hasAddOn = this.cartHasExclusiveAddOn(cart, marker, offerElement);
          const discountCode = String(offerElement.dataset.exclusiveDiscountCode || '').trim();

          if (hasAddOn && marker) attributes[marker] = 'Sì';
          if (discountCode) configuredDiscountCodes.push(discountCode);
          if (discountCode && this.cartDiscountEligible(cart, offerElement)) discountCodes.push(discountCode);
        });

        if (Object.keys(attributes).length) payload.attributes = attributes;
        if (configuredDiscountCodes.length) payload.discount = [...new Set(discountCodes)].join(',');
        if (!Object.keys(payload).length) return;

        await fetch(this.cartEndpoint('update'), {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      } catch (error) {}
    }


    async refreshCart(source, itemCount, variantId) {
      try {
        const response = await fetch(this.cartEndpoint('cart'), { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: source,
            data: {
              source,
              itemCount: cart.item_count || itemCount,
              variantId
            }
          }
        }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {}
    }

    openCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      const drawer = document.querySelector('cart-drawer, cart-drawer-component');

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }

      const opener = document.querySelector('drawer-opener [aria-controls], drawer-opener button, [data-testid="cart-drawer-trigger"], #cart-icon-bubble, [data-cart-drawer-toggle], [data-cart-toggle]');
      if (opener instanceof HTMLElement) {
        opener.click();
        return;
      }

      window.location.assign(this.dataset.cartUrl ? this.dataset.cartUrl.replace(/\.js$/, '') : `${this.cartRoot()}cart`);
    }
  }

  if (!customElements.get('bundle-offer')) customElements.define('bundle-offer', BundleOffer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-color-marquee"] && !Shopify.designMode) return;
  try {
    
  const initVariantColorMarquee = (root = document) => {
    root.querySelectorAll('[data-variant-color-marquee]').forEach((section) => {
      if (section.dataset.variantColorMarqueeReady === 'true') return;
      section.dataset.variantColorMarqueeReady = 'true';

      const viewport = section.querySelector('.variant-color-marquee__viewport');
      const track = section.querySelector('.variant-color-marquee__track');
      const firstGroup = section.querySelector('.variant-color-marquee__group');
      const previous = section.querySelector('[data-variant-color-marquee-prev]');
      const next = section.querySelector('[data-variant-color-marquee-next]');
      if (!viewport || !track || !firstGroup) return;

      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;
      let lastFrameTime = 0;
      let interactionTimer;

      const getLoopWidth = () => firstGroup.getBoundingClientRect().width;

      const getSpeed = () => {
        const speedSeconds = Number.parseFloat(section.dataset.marqueeSpeed) || 28;
        const loopWidth = getLoopWidth();
        return loopWidth > 0 ? loopWidth / (speedSeconds * 1000) : 0;
      };

      const normalizeScroll = () => {
        const loopWidth = getLoopWidth();
        if (loopWidth <= 0) return;

        if (viewport.scrollLeft >= loopWidth) {
          viewport.scrollLeft -= loopWidth;
        }
      };

      const pauseTemporarily = () => {
        section.classList.add('is-interacting');
        window.clearTimeout(interactionTimer);
        interactionTimer = window.setTimeout(() => {
          section.classList.remove('is-interacting');
        }, 1400);
      };

      const pausePermanently = () => {
        section.classList.add('is-paused');
        section.classList.remove('is-interacting');
        window.clearTimeout(interactionTimer);
      };

      const getStep = () => {
        const item = firstGroup.querySelector('.variant-color-marquee__item');
        if (!item) return viewport.clientWidth * 0.8;
        const styles = window.getComputedStyle(firstGroup);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return item.getBoundingClientRect().width + gap;
      };

      const slideManually = (direction) => {
        pausePermanently();
        const loopWidth = getLoopWidth();
        const step = getStep() * direction;

        if (direction < 0 && viewport.scrollLeft <= getStep() && loopWidth > 0) {
          viewport.scrollLeft += loopWidth;
        }

        viewport.scrollBy({ left: step, behavior: 'smooth' });
      };

      const shouldAutoplay = () => {
        return !section.classList.contains('is-paused') && !section.classList.contains('is-interacting') && !isDragging && !document.hidden;
      };

      const animate = (time) => {
        if (!section.isConnected) return;

        if (!lastFrameTime) lastFrameTime = time;
        const elapsed = Math.min(time - lastFrameTime, 48);
        lastFrameTime = time;

        if (shouldAutoplay()) {
          viewport.scrollLeft += getSpeed() * elapsed;
          normalizeScroll();
        }

        window.requestAnimationFrame(animate);
      };

      viewport.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'touch') {
          pausePermanently();
        }
      });

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') {
          pauseTemporarily();
          return;
        }

        isDragging = true;
        startX = event.clientX;
        startScrollLeft = viewport.scrollLeft;
        section.classList.add('is-dragging');
        pausePermanently();
        viewport.setPointerCapture(event.pointerId);
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!isDragging) return;
        event.preventDefault();
        viewport.scrollLeft = startScrollLeft - (event.clientX - startX);
        normalizeScroll();
      });

      const stopDragging = (event) => {
        if (!isDragging) return;
        isDragging = false;
        section.classList.remove('is-dragging');
        normalizeScroll();
        if (viewport.hasPointerCapture(event.pointerId)) {
          viewport.releasePointerCapture(event.pointerId);
        }
      };

      viewport.addEventListener('pointerup', stopDragging);
      viewport.addEventListener('pointercancel', stopDragging);
      if (previous) {
        previous.addEventListener('click', () => slideManually(-1));
      }

      if (next) {
        next.addEventListener('click', () => slideManually(1));
      }

      viewport.addEventListener('wheel', pausePermanently, { passive: true });
      viewport.addEventListener('touchstart', pauseTemporarily, { passive: true });
      viewport.addEventListener('touchend', () => {
        pauseTemporarily();
        normalizeScroll();
      }, { passive: true });

      window.requestAnimationFrame(animate);
    });
  };

  initVariantColorMarquee();
  document.addEventListener('shopify:section:load', (event) => initVariantColorMarquee(event.target));

  } catch(e) { console.error(e); }
})();
})();
